export default __webpack_public_path__ + "static/media/settings.407fda7e.svg";